import { IAquaApplicationDetails } from "../../models/AquaApplicationDetails";
import { IAquaPreference } from "../../models/AquaPreference";
import { IAquaSamplesAndTests } from "../../models/AquaSamplesAndTests";
import { IChooseApp } from "../../models/ChooseApp";
import { IFilerInformation } from "../../models/FilerInformation";
import { IPersonalInfo } from "../../models/PersonalInfo";

export interface IAquaRequest {
  labAQUAPersonalInfoDetails: IPersonalInfo;
  labAQUAChooseApplDetails: IChooseApp;
  labAQUAApplicationDetails: IAquaApplicationDetails;
  labAQUASampleTestDetails: IAquaSamplesAndTests[];
  labAQUAPreference: IAquaPreference;
  labApplicationchangedDetails?: IAquaApplicationDetails;
  labChangedPreference?: IAquaPreference;
  labchangedSampleTestDetails?: IAquaSamplesAndTests[];
  actionStatus?: string;
  applicationNumber?: string;
  submittedFeedback?: number;
  isReportGenerated?: number;
  reasonForCancellation?: string;
  labReportDetails?: string;
  labAQUAFilerInfoDetails: IFilerInformation;
  labAQUAApplicationStatus?: IAQUAApplicationStatus;
}

export interface IAQUAApplicationStatus {
  applicationRequestFor: number;
  miiApplication: number;
  eserviceApplication: number;
  actionedStatus?: string;
  ActionRequest: string;
  amendmentRaisedStage?: number | null;
  islabapplicationamended?: number;
  islabapplicationcancelled?: number;
  islabapplicationDuplicated?: number;
}
export const defAQUAAmmendAppStatus: IAQUAApplicationStatus = {
  applicationRequestFor: 2,
  islabapplicationamended: 1,
  miiApplication: 18,
  eserviceApplication: 14,
  ActionRequest: "Amendment request",
};
export const defAQUAmmendRowAppStatus: IAQUAApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 30,
  eserviceApplication: 20,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};
export const defAQUACancelAppStatus: IAQUAApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 25,
  eserviceApplication: 17,
  islabapplicationcancelled: 1,
  ActionRequest: "Cancel request",
};
export const defAQUAAppStatus: IAQUAApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};
export const defAQUAPostStatus: IAQUAApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 1,
  eserviceApplication: 1,
  ActionRequest: "Application Submitted",
};
export const defAQUAExchangeAppStatus: IAQUAApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};

export const defAmendmentRaisedStage = {
  "Pending Payment": 1,
  "Pending Sample(s)": 2,
  "Sample(s) Received": 3,
  "Testing In Progress": 6,
  "Pending Report Release": 7,
  "Report Released": 8,
  "Application Closed": 9,
  "Report Hard Copy Collected": 12,
};
